module.exports = __webpack_public_path__ + "statics/img/income-card-3.b75a0e49.png";